export const abbreviations = {
  assist: 'A',
  'average points per game': 'PTS/G',
  'winning percentage': 'WPCT',
  'in-division winning percentage': 'WPCTD',
  'games played': 'GP',
  goal: 'G',
  'goal differential': 'DIFF',
  'goals against': 'GA',
  'goals against average': 'GAA',
  'goals for': 'GF',
  loss: 'L',
  'minutes played': 'Min',
  'overtime losses': 'OTL',
  'penalty minutes': 'PiM',
  points: 'PTS',
  'regulation & overtime wins': 'ROW',
  save: 'SV',
  'save percentage': 'SV%',
  'shootout loss': 'SOL',
  'shots against': 'SA',
  shutouts: 'SO',
  season: 'season',
  tie: 'T',
  win: 'W',
  org: 'org',
  'game percentage': 'GPCT',
}

export const tooltips = {
  assist: 'Assists',
  'average points per game': 'Average Points Per Game',
  'winning percentage': 'Winning Percentage',
  'in-division winning percentage': 'In-Division Winning Percentage',
  'games played': 'Games Played',
  goal: 'Goals',
  'goal differential': 'DIFF',
  'goals against': 'Goals Against',
  'goals against average': 'GAA',
  'goals for': 'Goals For',
  loss: 'Losses',
  'minutes played': 'Minutes Played',
  'overtime losses': 'Overtime Losses',
  'penalty minutes': 'Penalty Minutes',
  points: 'Points',
  'regulation & overtime wins': 'Regulation and Overtime Wins',
  save: 'Saves',
  'save percentage': 'Save Percentage',
  'shootout loss': 'Shootout Losses',
  'shots against': 'Shots Against',
  shutouts: 'Shutouts',
  season: 'season',
  tie: 'Ties',
  win: 'Wins',
  org: 'org',
}

// i.e. standings
export const team = [
  'games played',
  'win',
  'loss',
  'tie',
  'overtime losses',
  'shootout loss',
  'points',
  'winning percentage',
  'in-division winning percentage',
  'goals for',
  'goals against',
  'game percentage',
  'penalty minutes',
  // 'goal differential',
  'regulation & overtime wins',
]

const playerByTeam = [
  'goal',
  'assist',
  'points',
  'penalty minutes',
  'average points per game',
]

export const player = ['games played', ...playerByTeam]

export const goalie = [
  'games played',
  'win',
  'loss',
  'tie',
  'overtime losses',
  'goals against average',
  'save percentage',
  'shutouts',
  'minutes played',
  'penalty minutes',
  'shots against',
  'save',
  'goals against',
]

export const gamePlayer = player.filter((f) => f !== 'average points per game')
export const gameGoalie = goalie.filter((f) => f !== 'goals against average')

export default {
  abbreviations,
  team,
  playerByTeam,
  player,
  goalie,
  gamePlayer,
  gameGoalie,
  tooltips,
}
